module.exports = __webpack_public_path__ + "img/006徐向南.e14410eb.jpg";